import { render } from "./TranslateBasicData.vue?vue&type=template&id=00a98a60"
import script from "./TranslateBasicData.vue?vue&type=script&lang=js"
export * from "./TranslateBasicData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__